import { render, staticRenderFns } from "./deanHeaderItem.vue?vue&type=template&id=12376698&scoped=true"
import script from "./deanHeaderItem.vue?vue&type=script&lang=ts"
export * from "./deanHeaderItem.vue?vue&type=script&lang=ts"
import style0 from "./deanHeaderItem.vue?vue&type=style&index=0&id=12376698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12376698",
  null
  
)

export default component.exports